import { Link } from "react-router-dom";
import { allCategories, getCategoryCount } from "@/data/videos";

export default function CategoryStrip() {
  return (
    <section className="container-page py-10 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
            视频分类
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            覆盖电影、剧集、综艺、动画、纪录片与短视频，总有一类适合你
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6 md:gap-4">
        {allCategories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group cursor-pointer rounded-lg border border-background-200/70 bg-background-100 p-4 transition-colors duration-300 hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-transform duration-300 group-hover:scale-105">
              <i className={`${cat.icon} text-xl`}></i>
            </span>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
              {cat.name}
            </h3>
            <p className="mt-0.5 text-xs text-foreground-500">
              {getCategoryCount(cat.id)} 部作品
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}